import React from 'react';
import CONFIG from '../../../config';

import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetSelect from '../../../components/widgets/WidgetSelect';
import WidgetInputTextList from '../../../components/widgets/WidgetInputTextList';

import 'dayjs/locale/fr';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import axios from "axios";
import Base64 from 'crypto-js/enc-base64';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HomeIcon from '@mui/icons-material/Home';
import Link from '@mui/material/Link';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import sha256 from 'crypto-js/sha256';
import WorkIcon from '@mui/icons-material/Work';
import CallIcon from '@mui/icons-material/Call';
import EuroIcon from '@mui/icons-material/Euro';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import GroupsIcon from '@mui/icons-material/Groups';
import WidgetProgress from '../../../components/widgets/WidgetProgress';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tab, Tabs } from '@mui/material';
import WidgetInputVille from '../../../components/widgets/WidgetInputVille';
import WidgetInputVilleList from '../../../components/widgets/WidgetInputVilleList';


function Questionnaire({ current = null, setCurrent = null, admin = false }) {
  const navigate = useNavigate();

  const [secteurOption, setSecteurOption] = React.useState({});
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_secteurs', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            let res = {};
            for (let i = 0; i < response.data.length; i++) {
              const secteurItem = response.data[i];
              res[secteurItem.toLowerCase()] = secteurItem;
            }
            res["autre"] = "Autre...";

            setSecteurOption(res);
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  const [user, setUser] = React.useState(current);
  const [errors, setErrors] = React.useState([]);
  const [editable, setEditable] = React.useState(admin);
  const [open, setOpen] = React.useState(false);
  const handleChangeTab = (_, newValue) => {
    setCurrentPage(newValue);
  };
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (user === null) {
      axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
        .then((response) => {
          switch (response.status) {
            case 200:
              setUser(response.data);
              const tmpEditable = response.data.dossier.questionnaire_etat === 'manquant' || response.data.dossier.questionnaire_etat === 'attente' || response.data.dossier.questionnaire_etat === 'rejet' || admin;
              setEditable(tmpEditable);
              setOpen(response.data.dossier.questionnaire_etat !== 'manquant' && tmpEditable && !admin);
              break;

            default:
              break;
          }
        })
        .catch((e) => {
          let response = e.response;

          if (response === undefined) {
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            return;
          }

          switch (response.status) {
            case 401:
              navigate('/connexion');
              break;

            default:
              alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
              break;
          }
        });
    }
  }, []);


  var formList = [];
  const pushReturn = (array, item) => { array.push(item); return item; };


  const [nom, setNom] = pushReturn(formList, React.useState(null));
  const [prenom, setPrenom] = pushReturn(formList, React.useState(null));
  const [email, setEmail] = pushReturn(formList, React.useState(null));
  const [telephone, setTelephone] = pushReturn(formList, React.useState(null));

  const [civilite, setCivilite] = pushReturn(formList, React.useState(null));
  const [nomNaissance, setNomNaissance] = pushReturn(formList, React.useState(null));
  const [listePrenom, setListePrenom] = pushReturn(formList, React.useState(null));

  const [dateNaissance, setDateNaissance] = pushReturn(formList, React.useState(null));
  const [villeNaissance, setVilleNaissance] = pushReturn(formList, React.useState(null));
  const [paysNaissance, setPaysNaissance] = pushReturn(formList, React.useState(null));

  const [situationMatrimoniale, setSituationMatrimoniale] = pushReturn(formList, React.useState(null));
  const [situationProfessionnelle, setSituationProfessionnelle] = pushReturn(formList, React.useState(null));
  const [nombreEnfant, setNombreEnfant] = pushReturn(formList, React.useState(null));
  const [ageEnfants, setAgeEnfants] = pushReturn(formList, React.useState(null));
  const [nombreEnfantNaitre, setNombreEnfantNaitre] = pushReturn(formList, React.useState(null));
  const [nombreAutresCharge, setNombreAutresCharge] = pushReturn(formList, React.useState(null));
  const [revenuNet, setRevenuNet] = pushReturn(formList, React.useState(null));
  const [ratacheFiscal, setRatacheFiscal] = pushReturn(formList, React.useState(null));

  const [adresse, setAdresse] = pushReturn(formList, React.useState(null));
  const [codePostal, setCodePostal] = pushReturn(formList, React.useState(null));
  const [ville, setVille] = pushReturn(formList, React.useState(null));
  const [pays, setPays] = pushReturn(formList, React.useState(null));
  const [typeLogementActuel, setTypeLogementActuel] = pushReturn(formList, React.useState(null));


  const [tailleEntreprise, setTailleEntreprise] = pushReturn(formList, React.useState(null));
  const [entreprisePrivee, setEntreprisePrivee] = pushReturn(formList, React.useState(null));
  const [entrepriseAgri, setEntrepriseAgri] = pushReturn(formList, React.useState(null));
  const [nomEntreprise, setNomEntreprise] = pushReturn(formList, React.useState(null));

  const [typeContrat, setTypeContrat] = pushReturn(formList, React.useState(null));
  const [avecEssai, setAvecEssai] = pushReturn(formList, React.useState(null));
  const [dateEmbauche, setDateEmbauche] = pushReturn(formList, React.useState(null));
  const [dateMutation, setDateMutation] = pushReturn(formList, React.useState(null));
  const [dateFinContrat, setDateFinContrat] = pushReturn(formList, React.useState(null));
  const [dateFinEssai, setDateFinEssai] = pushReturn(formList, React.useState(null));
  const [mute, setMute] = pushReturn(formList, React.useState(null));

  const [nomRh, setNomRh] = pushReturn(formList, React.useState(null));
  const [prenomRh, setPrenomRh] = pushReturn(formList, React.useState(null));
  const [emailRh, setEmailRh] = pushReturn(formList, React.useState(null));
  const [telephoneRh, setTelephoneRh] = pushReturn(formList, React.useState(null));


  const [secteurRecherche, setSecteurRecherche] = pushReturn(formList, React.useState(null));
  const [secteurRecherchePrecision, setSecteurRecherchePrecision] = pushReturn(formList, React.useState(null));
  const [villeRecherche, setVilleRecherche] = pushReturn(formList, React.useState(null));

  const [typeAppartementRecherche, setTypeAppartementRecherche] = pushReturn(formList, React.useState(null));
  const [typeMeuble, setTypeMeuble] = pushReturn(formList, React.useState(null));
  const [equipementObligatoire, setEquipementObligatoire] = pushReturn(formList, React.useState(null));
  const [equipementOptionnel, setEquipementOptionnel] = pushReturn(formList, React.useState(null));
  const [maxLoyer, setMaxLoyer] = pushReturn(formList, React.useState(null));
  const [minSurface, setMinSurface] = pushReturn(formList, React.useState(null));


  const [currentPage, setCurrentPage] = React.useState(0);


  const nextPage = () => setCurrentPage(x => x + 1);
  const prevPage = () => setCurrentPage(x => x - 1);

  const saveAndNextPage = () => {
    let payload = {};

    for (var i = 0; i < formList.length; i++) {
      let [field, setField] = formList[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    axios.post(CONFIG.API_URL + '/api/client_save_questionnaire/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            nextPage();
            if (setCurrent !== null)
              setCurrent(response.data)
            setUser(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 412:
            alert("Email déjà existant.");
            break;

          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };

  React.useEffect(() => {
    if (codePostal !== null && codePostal?.value !== user.dossier.adresse_depart.code_postal) {
      setVille((s) => ({ ...s, value: '' }));
    }
  }, [codePostal]);


  const submitQuestionnaire = () => {
    var formQuestionnaireValid = true;
    var errorPage = null;

    if (nom === null || nom.value === '') {
      setNom((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (prenom === null || prenom.value === '') {
      setPrenom((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (email === null || email.value === '') {
      setEmail((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (telephone === null || telephone.value === '') {
      setTelephone((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }


    if (civilite === null || civilite.value === '') {
      setCivilite((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (nomNaissance === null) {
      setNomNaissance((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (listePrenom === null) {
      setListePrenom((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (dateNaissance === null || dateNaissance.value === null) {
      setDateNaissance((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (villeNaissance === null || villeNaissance.value === '') {
      setVilleNaissance((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }

    if (paysNaissance === null || paysNaissance.value === '') {
      setPaysNaissance((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 0;
      formQuestionnaireValid = false;
    }


    if (adresse === null || adresse.value === '') {
      setAdresse((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (codePostal === null || codePostal.value === '') {
      setCodePostal((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (ville === null || ville.value === '') {
      setVille((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (typeLogementActuel === null || typeLogementActuel.value === '') {
      setTypeLogementActuel((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (situationMatrimoniale === null || situationMatrimoniale.value === '') {
      setSituationMatrimoniale((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (situationProfessionnelle === null || situationProfessionnelle.value === '') {
      setSituationProfessionnelle((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (nombreEnfant === null || nombreEnfant.value === '') {
      setNombreEnfant((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (nombreEnfantNaitre === null || nombreEnfantNaitre.value === '') {
      setNombreEnfantNaitre((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (nombreAutresCharge === null || nombreAutresCharge.value === '') {
      setNombreAutresCharge((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (ageEnfants === null || (ageEnfants?.value.length !== parseInt(nombreEnfant.value))) {
      setAgeEnfants((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }

    if (revenuNet === null || revenuNet.value === '') {
      setRevenuNet((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }

    if (ratacheFiscal === null) {
      setRatacheFiscal((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 1;
      formQuestionnaireValid = false;
    }



    if (nomEntreprise === null || nomEntreprise.value === '') {
      setNomEntreprise((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }

    if (tailleEntreprise === null || tailleEntreprise.value === '') {
      setTailleEntreprise((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }

    if (entreprisePrivee === null || entreprisePrivee.value === '') {
      setEntreprisePrivee((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }

    if (entrepriseAgri === null || entrepriseAgri.value === '') {
      setEntrepriseAgri((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }


    if (typeContrat === null || typeContrat.value === '') {
      setTypeContrat((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }

    if (avecEssai === null) {
      setAvecEssai((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }

    if (dateEmbauche === null || dateEmbauche.value === null) {
      setDateEmbauche((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }

    const dateFinContratRequired = (typeContrat.value === 'cdd' || typeContrat.value === 'alternance');
    if (dateFinContratRequired && (dateFinContrat === null || dateFinContrat.value === null)) {
      setDateFinContrat((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }

    const dateFinEssaiRequired = avecEssai.value  // && (typeContrat.value === 'cdd' || typeContrat.value === 'cdi');
    if (dateFinEssaiRequired && (dateFinEssai === null || dateFinEssai.value === null)) {
      setDateFinEssai((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 2;
      formQuestionnaireValid = false;
    }



    if (secteurRecherche === null || secteurRecherche.value === '') {
      setSecteurRecherche((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 3;
      formQuestionnaireValid = false;
    }

    const secteurRecherchePrecisionRequired = secteurRecherche.value === 'autre';
    if (secteurRecherchePrecisionRequired && (secteurRecherchePrecision === null || secteurRecherchePrecision.value === '')) {
      setSecteurRecherchePrecision((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 3;
      formQuestionnaireValid = false;
    }

    if (villeRecherche === null || villeRecherche.value.length === 0) {
      setVilleRecherche((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 3;
      formQuestionnaireValid = false;
    }

    if (typeAppartementRecherche === null || typeAppartementRecherche.value.length === 0) {
      setTypeAppartementRecherche((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 3;
      formQuestionnaireValid = false;
    }

    if (typeMeuble === null || typeMeuble.value === '') {
      setTypeMeuble((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 3;
      formQuestionnaireValid = false;
    }

    if (equipementObligatoire === null) {
      setEquipementObligatoire((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 3;
      formQuestionnaireValid = false;
    }

    if (equipementOptionnel === null) {
      setEquipementOptionnel((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 3;
      formQuestionnaireValid = false;
    }

    if (maxLoyer === null || maxLoyer.value === '') {
      setMaxLoyer((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 3;
      formQuestionnaireValid = false;
    }

    if (minSurface === null || minSurface.value === '') {
      setMinSurface((s) => ({ ...s, error: true }));
      if (errorPage === null) errorPage = 3;
      formQuestionnaireValid = false;
    }


    if (!formQuestionnaireValid) {
      setCurrentPage(errorPage);
      return;
    }


    let payload = {};

    for (var i = 0; i < formList.length; i++) {
      let [field, setField] = formList[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    axios.post(CONFIG.API_URL + '/api/client_submit_questionnaire/' + user._id, payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            if (!admin)
              navigate('/client/dossier');
            if (setCurrent !== null)
              setCurrent(response.data)
            setUser(response.data);
            setErrors([]);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 412:
            setErrors(Object.keys(response.data.detail).map(key => (response.data.detail[key])));
            break;

          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };


  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Attention"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            En modifiant les réponses du questionnaire vous risquez de modifier la liste des documents qui vous sont demandé.
            Par ailleurs, pensez bien à revalider le questionnaire à la fin si vous le modifiez.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      {user &&
        <>
          <div className='max-w-4xl mx-auto shrink-0'>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-6'>
              <div className='col-span-12 w-full text-center mb-2'>
                <h1>Informations personnelles</h1>
                Les champs obligatoires apparaîtront en surbrillance si manquants.
              </div>
              <div className='col-span-12 w-full text-center'>
                <Tabs value={currentPage} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
                  <Tab label="Identité" id="simple-tab-0" />
                  <Tab label="Situation actuelle" id="simple-tab-1" />
                  <Tab label="Emploi" id="simple-tab-2" />
                  <Tab label="Bien recherché" id="simple-tab-3" />
                  <Tab label="Finaliser" id="simple-tab-4" />
                </Tabs>
              </div>
            </div>
          </div>

          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 0) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <CallIcon fontSize='large'></CallIcon>
                </div>
                <div>
                  <h2>Informations de contact</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nom} setState={setNom} id={'nom'} text={"Nom"} value={user.nom} readOnly={!editable} />
              </div>



              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={prenom} setState={setPrenom} id={'prenom'} text={"Prénom"} value={user.prenom} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={email} setState={setEmail} id={'email'} text={"Email"} regex={"^.+@.+$"} regex_helper={"Adresse email non-valide"} value={user.email} disabled={!admin} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={telephone} setState={setTelephone} id={'telephone'} text={"Téléphone"} regex_key={"[+0-9 ]"} value={user.telephone} readOnly={!editable} />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <PersonIcon fontSize='large'></PersonIcon>
                </div>
                <div>
                  <h2>Informations personnelles</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nomNaissance} setState={setNomNaissance} id={'dossier___nom_naissance'} text={"Nom de naissance"} value={user.dossier.nom_naissance} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={civilite} setState={setCivilite} id={'dossier___civilite'} text={"Civilité"} value={(user.dossier.civilite === null) ? '' : user.dossier.civilite} readOnly={!editable}
                  options={{
                    true: "M.",
                    false: "Mme."
                  }}
                />
              </div>

              <div className='col-span-12 w-full mb-4'>
                <WidgetInputTextList state={listePrenom} setState={setListePrenom} id={'dossier___liste_prenom'} text={"Autres prénoms"} value={user.dossier.liste_prenom} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetDatePicker state={dateNaissance} setState={setDateNaissance} id={'dossier___date_naissance'} text={"Date de naissance"} value={user.dossier.date_naissance} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={villeNaissance} setState={setVilleNaissance} id={'dossier___ville_naissance'} text={"Ville de naissance"} value={user.dossier.ville_naissance} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={paysNaissance} setState={setPaysNaissance} id={'dossier___pays_naissance'} text={"Pays de naissance"} value={user.dossier.pays_naissance} readOnly={!editable} />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-start-1 col-span-6 w-full mt-2 text-left'>
                <Button variant='outlined' onClick={() => navigate("/client/dossier")}>
                  Annuler
                </Button>
              </div>
              <div className='col-span-6 w-full mt-2 text-right'>
                <Button variant='contained' onClick={(editable) ? saveAndNextPage : nextPage}>
                  {(editable) ? "Enregistrer et passer à la suite" : "Suivant"}
                </Button>
              </div>
              <div className='col-span-12 w-full mt-6 text-xs text-justify'>
                En tant que responsable de traitement, Mouv'Immo collecte vos données à caractère personnel aux fins notamment
                de la création et de la gestion de votre compte utilisateur, de l'instruction et le suivi de votre demande, de la réalisation
                d'enquêtes de satisfaction, d'études marketing et statistiques. Vos données sont destinées aux différents services
                administratifs, commercial, marketing de Mouv'Immo, aux organismes en charge de votre prise en charge et aux
                partenaires en charge de la recherche de biens. Vos données seront conservées le temps nécessaire à l'exécution des
                différentes démarches et selon notre politique de conservation des données. Les données mentionnées par un
                astérisque (*) sont obligatoires. Conformément à la Loi Informatique et Liberté Loi n° 78-17 du 6 janvier 1978 modifiée
                et au Règlement Général sur la Protection des Données Règlement (UE) 2016/679 du Parlement européen et du Conseil
                du 27 avril 2016 dit RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition
                au traitement de vos données. Vous pouvez exercer vos droits en envoyant un mail à agence@mouv-immo.com ou
                par courrier à Mouv'Immo, 16 rue Lieutenant-Colonel Prévost, 69006 Lyon. Pour plus d'informations concernant le
                traitement de vos données à caractère personnel, vous pouvez consulter notre politique en ligne.
              </div>
            </div>
          </div>













          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 1) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <HomeIcon fontSize='large'></HomeIcon>
                </div>
                <div>
                  <h2>Logement de départ</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <WidgetInputText state={adresse} setState={setAdresse} id={'dossier___adresse_depart___adresse'} text={"Adresse"} value={user.dossier.adresse_depart.adresse} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={codePostal} setState={setCodePostal} id={'dossier___adresse_depart___code_postal'} text={"Code postal"} value={user.dossier.adresse_depart.code_postal} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputVille state={ville} setState={setVille} code_postal={codePostal?.value} id={'dossier___adresse_depart___ville'} text={"Ville"} value={user.dossier.adresse_depart.ville} readOnly={!editable} />
              </div>

              {codePostal !== null && codePostal.value === '99999' &&
                <div className='col-span-6 w-full mb-4'>
                  <WidgetInputText state={pays} setState={setPays} id={'dossier___adresse_depart___pays'} text={"Pays"} value={user.dossier.adresse_depart.pays} readOnly={!editable} />
                </div>
              }

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={typeLogementActuel} setState={setTypeLogementActuel} id={'dossier___type_logement_actuel'} text={"Type de logement"} value={user.dossier.type_logement_actuel} readOnly={!editable}
                  options={{
                    'locataire': "Locataire",
                    'proprietaire': "Propriétaire",
                    'heberge': "Hebergé"
                  }}
                />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <EuroIcon fontSize='large'></EuroIcon>
                </div>
                <div>
                  <h2>Situation actuelle</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={situationMatrimoniale} setState={setSituationMatrimoniale} id={'dossier___situation_matrimoniale'} text={"Situation matrimoniale"} value={user.dossier.situation_matrimoniale} readOnly={!editable}
                  options={{
                    'celibataire': "Célibataire",
                    'union': "Union libre",
                    'pacse': "Pacsé",
                    'marie': "Marié",
                    'serpare': "Séparé",
                    'divorce': "Divorcé",
                    'veuf': "Veuf"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nombreEnfant} setState={setNombreEnfant} id={'dossier___nombre_enfant'} text={"Nombre d'enfant à charge"} value={user.dossier.nombre_enfant} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nombreEnfantNaitre} setState={setNombreEnfantNaitre} id={'dossier___nombre_enfant_naitre'} text={"Nombre d'enfant à naitre"} value={user.dossier.nombre_enfant_naitre} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nombreAutresCharge} setState={setNombreAutresCharge} id={'dossier___nombre_autres_charge'} text={"Autres personnes à charge"} value={user.dossier.nombre_autres_charge} readOnly={!editable} />
              </div>

              <div className='col-span-12 w-full mb-4'>
                <WidgetInputTextList state={ageEnfants} setState={setAgeEnfants} id={'dossier___age_enfants'} text={"Ages des enfants"} value={user.dossier.age_enfants} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={situationProfessionnelle} setState={setSituationProfessionnelle} id={'dossier___situation_professionnelle'} text={"Situation professionnelle"} value={user.dossier.situation_professionnelle} readOnly={!editable}
                  options={{
                    'salarie': "Salarié",
                    'publique': "Fonctionnaire",
                    'tns': "Chef d'entreprise/indépendant",
                    'retraite': "Retraité",
                    'sans_emploi': "Sans emploi",
                    'etudiant': "Etudiant",
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4 pt-2 pl-2'>
                <WidgetCheckbox state={ratacheFiscal} setState={setRatacheFiscal} id={'dossier___ratache_fiscalement'} text={"Rattaché fiscalement"} value={user.dossier.ratache_fiscalement} disabled={!editable} />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-start-1 col-span-6 w-full mt-2 text-left'>
                <Button variant='outlined' onClick={prevPage}>
                  Précédent
                </Button>
              </div>
              <div className='col-span-6 w-full mt-2 text-right'>
                <Button variant='contained' onClick={(editable) ? saveAndNextPage : nextPage}>
                  {(editable) ? "Enregistrer et passer à la suite" : "Suivant"}
                </Button>
              </div>
            </div>
          </div>













          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 2) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <WorkIcon fontSize='large'></WorkIcon>
                </div>
                <div>
                  <h2>Entreprise</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nomEntreprise} setState={setNomEntreprise} id={'dossier___nom_entreprise'} text={"Nom de votre entreprise"} value={user.dossier.nom_entreprise} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={tailleEntreprise} setState={setTailleEntreprise} id={'dossier___taille_entreprise'} text={"Taille d'entreprise"} value={user.dossier.taille_entreprise} readOnly={!editable}
                  options={{
                    '1-9': "1 à 9 employés (siège compris)",
                    '10-49': "10 à 49 employés (siège compris)",
                    '50-199': "50 à 199 salariés (siège compris)",
                    '200-999': "200 à 999 salariés (siège compris)",
                    '1000+': "+1000 salariés (siège compris)"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4 grid content-start'>
                <WidgetSelect state={entreprisePrivee} setState={setEntreprisePrivee} id={'dossier___entreprise_privee'} text={"Entreprise privée"} value={user.dossier.entreprise_privee} readOnly={!editable}
                  options={{
                    'true': "Entreprise privée",
                    'false': "Entreprise publique"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4 grid content-start'>
                <WidgetCheckbox state={entrepriseAgri} setState={setEntrepriseAgri} id={'dossier___entreprise_agri'} text={"Entreprise agricole"} value={user.dossier.entreprise_agri} readOnly={true} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={revenuNet} setState={setRevenuNet} id={'dossier___revenu_net'} text={"Revenu net"} regex_key={"[0-9\. ]"} value={user.dossier.revenu_net} readOnly={!editable} />
                {(typeContrat === null || typeContrat.value !== 'alternance') && <span className='text-xs'>(Les agences immobilières demandent que le revenu net couvre 3 fois le montant du loyer)</span>}
              </div>
            </div>


            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <AssignmentIcon fontSize='large'></AssignmentIcon>
                </div>
                <div>
                  <h2>Contrat</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={typeContrat} setState={setTypeContrat} id={'dossier___type_contrat'} text={"Type de contrat"} value={user.dossier.type_contrat} readOnly={!editable}
                  options={{
                    'cdi': "CDI",
                    'cdd': "CDD",
                    'alternance': "Alternance"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4 grid'>
                <WidgetDatePicker state={dateEmbauche} setState={setDateEmbauche} id={'dossier___date_embauche'} text={"Date d'embauche/mutation"} value={user.dossier.date_embauche} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4 content-center grid'>
                <WidgetCheckbox state={avecEssai} setState={setAvecEssai} id={'dossier___avec_essai'} text={"Avec période d'essai"} value={user.dossier.avec_essai} disabled={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4 content-center grid'>
                <WidgetCheckbox state={mute} setState={setMute} id={'dossier___mute'} text={"Mutation"} value={user.dossier.mute} disabled={!editable} />
              </div>

              {mute !== null && mute.value &&
                <div className='col-span-6 w-full mb-4 grid'>
                  <WidgetDatePicker state={dateMutation} setState={setDateMutation} id={'dossier___date_mutation'} text={"Date de mutation"} value={user.dossier.date_mutation} readOnly={!editable} />
                </div>
              }

              {typeContrat !== null && (typeContrat.value === 'cdd' || typeContrat.value === 'alternance') &&
                <div className='col-span-6 w-full mb-4 grid'>
                  <WidgetDatePicker state={dateFinContrat} setState={setDateFinContrat} id={'dossier___date_fin_contrat'} text={"Date de fin de contrat"} value={user.dossier.date_fin_contrat} readOnly={!editable} />
                </div>
              }

              {avecEssai !== null && avecEssai.value &&
                <div className='col-span-6 w-full mb-4 grid'>
                  <WidgetDatePicker state={dateFinEssai} setState={setDateFinEssai} id={'dossier___date_fin_essai'} text={"Date de fin de période d'essai"} value={user.dossier.date_fin_essai} readOnly={!editable} />
                </div>
              }
            </div>


            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <CallIcon fontSize='large'></CallIcon>
                </div>
                <div>
                  <h2>Contact entreprise (RH, Directeur, Manager, etc.)</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nomRh} setState={setNomRh} id={'dossier___nom_rh'} text={"Nom de votre contact"} value={user.dossier.nom_rh} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={prenomRh} setState={setPrenomRh} id={'dossier___prenom_rh'} text={"Prénom de votre contact"} value={user.dossier.prenom_rh} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={emailRh} setState={setEmailRh} id={'dossier___email_rh'} text={"Email de votre contact"} regex={"^.+@.+$"} regex_helper={"Adresse email non-valide"} value={user.dossier.email_rh} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={telephoneRh} setState={setTelephoneRh} id={'dossier___telephone_rh'} text={"Téléphone de votre contact"} regex_key={"[+0-9 ]"} value={user.dossier.telephone_rh} readOnly={!editable} />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-start-1 col-span-6 w-full mt-2 text-left'>
                <Button variant='outlined' onClick={prevPage}>
                  Précédent
                </Button>
              </div>
              <div className='col-span-6 w-full mt-2 text-right'>
                <Button variant='contained' onClick={(editable) ? saveAndNextPage : nextPage}>
                  {(editable) ? "Enregistrer et passer à la suite" : "Suivant"}
                </Button>
              </div>
            </div>
          </div>













          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 3) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <LocationOnIcon fontSize='large'></LocationOnIcon>
                </div>
                <div>
                  <h2>Secteur de recherche</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={secteurRecherche} setState={setSecteurRecherche} id={'dossier___secteur_recherche'} text={"Secteur de recherche"} value={user.dossier.secteur_recherche} readOnly={!editable}
                  options={secteurOption}
                />
              </div>

              {secteurRecherche !== null && secteurRecherche.value === 'autre' &&
                <div className='col-span-6 w-full mb-4'>
                  <WidgetInputText state={secteurRecherchePrecision} setState={setSecteurRecherchePrecision} id={'dossier___secteur_recherche_precision'} text={"Précisez autre"} value={user.dossier.secteur_recherche_precision} readOnly={!editable} />
                </div>
              }

              <div className='col-span-12 w-full mb-4'>
                <WidgetInputVilleList state={villeRecherche} setState={setVilleRecherche} id={'dossier___villes_recherche'} text={"Villes de recherche"} value={user.dossier.villes_recherche} readOnly={!editable} />
              </div>
            </div>


            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <ManageSearchIcon fontSize='large'></ManageSearchIcon>
                </div>
                <div>
                  <h2>Critères de recherche</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={typeAppartementRecherche} setState={setTypeAppartementRecherche} id={'dossier___type_appartement_recherche'} text={"Type d'appartement recherché"} multiple={true} value={user.dossier.type_appartement_recherche} readOnly={!editable}
                  options={{
                    'studio': "Studio",
                    't2': "T2 (1 chambre)",
                    't3': "T3 (2 chambres)",
                    't4+': "T4 ou plus (3 chambres)"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={typeMeuble} setState={setTypeMeuble} id={'dossier___type_meuble'} text={"Meublé/Non meublé"} value={user.dossier.type_meuble} readOnly={!editable}
                  options={{
                    'osef': "Peu importe",
                    'meuble': "Meublé",
                    'non-meuble': "Non meublé"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={equipementObligatoire} setState={setEquipementObligatoire} id={'dossier___equipement_obligatoire'} text={"Equipements obligatoires"} multiple={true} value={user.dossier.equipement_obligatoire} readOnly={!editable}
                  options={{
                    'cuisine': "Cuisine",
                    'balcon': "Balcon/Terrasse",
                    'garage': "Garage/Stationnement"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={equipementOptionnel} setState={setEquipementOptionnel} id={'dossier___equipement_optionnel'} text={"Equipements facultatifs"} multiple={true} value={user.dossier.equipement_optionnel} readOnly={!editable}
                  options={{
                    'cuisine': "Cuisine",
                    'balcon': "Balcon/Terrasse",
                    'garage': "Garage/Stationnement"
                  }}
                />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={maxLoyer} setState={setMaxLoyer} id={'dossier___max_loyer'} text={"Loyer maximum"} regex_key={"[0-9\. ]"} value={user.dossier.max_loyer} readOnly={!editable} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={minSurface} setState={setMinSurface} id={'dossier___min_surface'} text={"Surface minimum"} regex_key={"[0-9\. ]"} value={user.dossier.min_surface} readOnly={!editable} />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-start-1 col-span-6 w-full mt-2 text-left'>
                <Button variant='outlined' onClick={prevPage}>
                  Précédent
                </Button>
              </div>
              <div className='col-span-6 w-full mt-2 text-right'>
                <Button variant='contained' onClick={(editable) ? saveAndNextPage : nextPage}>
                  {(editable) ? "Enregistrer et passer à la suite" : "Suivant"}
                </Button>
              </div>
            </div>
          </div>













          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 4) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <PlaylistAddCheckIcon fontSize='large'></PlaylistAddCheckIcon>
                </div>
                <div>
                  <h2>Valider les réponses</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-12 w-full mb-4'>
                {(editable) ? <>
                  La liste des pièces justificatives demandées se fera en fonction des réponses au questionnaire.
                  <br></br>
                  <br></br>
                  Vous pouvez à tout moment modifier vos réponses, cependant, cela pourrait modifier les justificatifs demandés.
                </> : "Réponses déjà validées."}
              </div>

              {errors.length !== 0 &&
                <div className='col-span-12 w-full mb-4 text-left'>
                  <Alert severity="error">
                    <AlertTitle>Erreur</AlertTitle>
                    <ul className='list-disc list-inside'>
                      {errors.map((x) => <li key={x}>{x}</li>)}
                    </ul>
                  </Alert>
                </div>
              }
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-start-1 col-span-6 w-full mt-2 text-left'>
                <Button variant='outlined' onClick={prevPage}>
                  Précédent
                </Button>
              </div>
              <div className='col-span-6 w-full mt-2 text-right'>
                <Button variant='contained' onClick={submitQuestionnaire} disabled={!editable}>
                  Valider les réponses
                </Button>
              </div>
            </div>
          </div>
        </>
      }
    </>
  );
}

export default Questionnaire;